import { DisplayOnce, ModalWrapper, TimeSwitch } from "src/utils/fw"

const timezone = "+0200"

const dayOne = {
    name: "dayOne2",
    starts: new Date(`2023-10-22 08:45:00${timezone}`),
    ends: new Date(`2023-10-23 08:44:00${timezone}`),
    content: <>
        <h1>WELCOME TO ROTTERDAM 2023 ONLINE: DAY TWO</h1>
        <p>Today's keynote speakers are Peter Hinssen and Nina Schick. </p>
        <p>Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members and tap into the knowledge of the ISF team. </p>
        <p>Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape.</p>
        <p>Go to our on-demand room to view yesterday's sessions.</p>
    </>
}

const dayTwo = {
    name: "dayTwo",
    starts: new Date(`2023-10-23 08:45:00${timezone}`),
    ends: new Date(`2023-10-24 7:59:00${timezone}`),
    content: <>
        <h1>WELCOME TO ROTTERDAM 2023 ONLINE: DAY TWO</h1>
        <p>Today's keynote speakers are Peter Hinssen and Nina Schick. </p>
        <p>Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members and tap into the knowledge of the ISF team. </p>
        <p>Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape.</p>
        <p>Go to our on-demand room to view yesterday's sessions.</p>
    </>
}

const dayThree = {
    name: "dayThree",
    starts: new Date(`2023-10-24 08:00:00${timezone}`),
    ends: new Date(`2023-10-24 13:29:00${timezone}`),
    content: <>
        <h1>WELCOME TO ROTTERDAM 2023 ONLINE: DAY THREE</h1>
        <p>Today's keynote speakers are Tali Sharot and Helle Thorning-Schmidt.</p>
        <p>Go to our on-demand room to view previous sessions. All sessions will be available to view on-demand after today's broadcast.</p>
    </>
}

const finale = {
    name: "finale",
    starts: new Date(`2023-10-24 13:30:00${timezone}`),
    ends: new Date(`2024-10-24 13:29:00${timezone}`),
    content: <>
        <h1>THANK YOU FOR ATTENDING ROTTERDAM 2023 ONLINE</h1>
        <p>Educational hours will be calculated based on your attendance, and certificates will be issued automatically approximately three weeks after the event. You will receive an email notification and you will also be able to access your certificate from your ISF profile.</p>
        <p>The Congress platform will remain open until Tuesday 14th November for you to browse content and watch sessions on demand.</p>
    </>
}

export default <TimeSwitch>
    {[
        {
            name: "dayZero",
            starts: new Date(`2023-10-20 08:45:00${timezone}`),
            ends: new Date(`2023-10-22 08:44:00${timezone}`),
            content: null
        },
        dayOne,
        dayTwo,
        dayThree,
        finale
    ].map(it => {

        return {
            ...it,
            content: it.content && <DisplayOnce id={it.name} dismissHTML="X" dismissStyle={{color: "white", fontSize: "18px", top: "9px", right: "13px"}}>
                <ModalWrapper wrapperStyle={{backgroundColor: "rgb(59, 80, 206)", color: "white"}}>
                    {it.content}
                </ModalWrapper>
            </DisplayOnce>
        }
    })}
</TimeSwitch>